import React from 'react'
import { formTypes } from "./../../Forms/Containers/FormCreator";

// import { getMasterRef } from "../../Services/service";
import { INFORM_GENERATOR } from '../../constants/strings/StringsDashboard'


export const indivdualObject = async (props) => {
  return [
    {
      type: formTypes.title,
      classContainer: "line line-100 align-center",
      classLabel: "input-text",
      label: "Información del hecho",
      variable: "title",
      value: ""
    },
    {
      type: formTypes.select,
      label: "Fenómenos",
      placeholder: "Seleccione fenómeno",
      required: false,
      classContainer: "line line-33",
      classLabel: "input-text",
      variable: "refMpioId",
      keyValue: "id",
      keyText: "text",
      data: INFORM_GENERATOR.FENOMENES,
      value: []
    },
    {
      type: formTypes.text,
      classContainer: "line line-33",
      classLabel: "input-text",
      label: "Barrio/Vereda",
      placeholder: "Nombre barrio/vereda",
      required: false,
      variable: "barrio",
      value: ""
    },
    {
      type: formTypes.select,
      label: "Zona",
      placeholder: "Seleccione tipo de zona",
      required: false,
      classContainer: "line line-33",
      classLabel: "input-text",
      variable: "refZonaId",
      keyValue: "id",
      keyText: "name",
      data: INFORM_GENERATOR.ZONES,
      value: []
    },
    {
      type: formTypes.number,
      classContainer: "line line-50",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "Latitud",
      placeholder: "Ej 3.543",
      required: false,
      variable: "lat",
      value: "",
      focusOut: props.focusOut
    },
    {
      type: formTypes.number,
      classContainer: "line line-50",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "Longitud",
      placeholder: "Ej -73.708",
      required: false,
      variable: "lng",
      value: "",
      focusOut: props.focusOut
    },
    {
      type: formTypes.text,
      classContainer: "line line-66",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "Dirección",
      placeholder: 'Ej: Calle 102 d # 78 - 104',
      required: false,
      variable: "direccion",
      value: ""
    },
    {
      type: formTypes.text,
      classContainer: "line line-33",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "SPOA",
      placeholder: "Ingrese por favor el SPOA",
      required: false,
      variable: "spoa",
    },
    {
      type: formTypes.divContainer,
      classContainer: "line line-100",
      visible: true,
      value: (
        <div className="map-murder" id="map-murder"></div>
      )
    },
    {
      type: formTypes.calendar,
      classContainer: "line line-33",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "Fecha del hecho",
      placeholder: "dd/mm/aaaa",
      required: false,
      variable: "fechaFenomeno"
      // value: new Date(),
    },
    {
      type: formTypes.select,
      label: "Hora(s)",
      placeholder: "Hora",
      required: false,
      classContainer: "line line-33",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "horaFenomeno",
      keyValue: "text",
      keyText: "text",
      data: [
        { text: "00" },
        { text: "01" },
        { text: "02" },
        { text: "03" },
        { text: "04" },
        { text: "05" },
        { text: "06" },
        { text: "07" },
        { text: "08" },
        { text: "09" },
        { text: "10" },
        { text: "11" },
        { text: "12" },
        { text: "13" },
        { text: "14" },
        { text: "15" },
        { text: "16" },
        { text: "17" },
        { text: "18" },
        { text: "19" },
        { text: "20" },
        { text: "21" },
        { text: "22" },
        { text: "23" }
      ],
      value: []
    },
    {
      type: formTypes.select,
      label: "Minuto(s)",
      placeholder: "Minuto",
      required: false,
      classContainer: "line line-33",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "minutoFenomeno",
      keyValue: "text",
      keyText: "text",
      data: [
        { text: "00" },
        { text: "01" },
        { text: "02" },
        { text: "03" },
        { text: "04" },
        { text: "05" },
        { text: "06" },
        { text: "07" },
        { text: "08" },
        { text: "09" },
        { text: "10" },
        { text: "11" },
        { text: "12" },
        { text: "13" },
        { text: "14" },
        { text: "15" },
        { text: "16" },
        { text: "17" },
        { text: "18" },
        { text: "19" },
        { text: "20" },
        { text: "21" },
        { text: "22" },
        { text: "23" },
        { text: "24" },
        { text: "25" },
        { text: "26" },
        { text: "27" },
        { text: "28" },
        { text: "29" },
        { text: "30" },
        { text: "31" },
        { text: "32" },
        { text: "33" },
        { text: "34" },
        { text: "35" },
        { text: "36" },
        { text: "37" },
        { text: "38" },
        { text: "39" },
        { text: "40" },
        { text: "41" },
        { text: "42" },
        { text: "43" },
        { text: "44" },
        { text: "45" },
        { text: "46" },
        { text: "47" },
        { text: "48" },
        { text: "49" },
        { text: "50" },
        { text: "51" },
        { text: "52" },
        { text: "53" },
        { text: "54" },
        { text: "55" },
        { text: "56" },
        { text: "57" },
        { text: "58" },
        { text: "59" }
      ],
      value: []
    },
    {
      type: formTypes.textarea,
      classContainer: "line line-100",
      // classContainer: "grid",
      classInput: "form-control",
      classLabel: "input-text",
      label:
        "Relato de los hechos (con circunstancias de tiempo, modo y lugar)",
      placeholder:
        "Ingrese el relato con circunstancias de tiempo, modo y lugar",
      required: false,
      variable: "notaCriminal",
      value: "",
      rows: 10, // este modifica el numero de lineas verticales
      display: "grid"
    },
    {
      type: formTypes.div,
      classContainer: "line line-100"
    },
    // {
    //   type: formTypes.title,
    //   classContainer: "line line-100 text-center",
    //   classLabel: "input-text",
    //   label: "Click en (+) para adicionar víctima",
    //   // required: true,
    //   variable: "title",
    //   value: ""
    // },
    {
      type: formTypes.div,
      classContainer: "line line-33"
    },
    // {
    //   type: formTypes.buttonclick,
    //   classContainer: "button-add line line-33 text-center",
    //   label: "+",
    //   placeholder: "-",
    //   onClick: props.addMurdered
    // },
    {
      type: formTypes.div,
      classContainer: "line line-100"
    },
    {
      type: formTypes.div,
      classContainer: "line line-25"
    },
    {
      type: formTypes.click,
      classContainer:
        "button-secondary line line-25 text-center",
      label: "Cancelar",
      placeholder: "-"
    },
    {
      type: formTypes.submit,
      classContainer: "button-primary line line-25 text-center",
      label: "Enviar",
      placeholder: "-"
    },
    {
      type: formTypes.div,
      classContainer: "line line-40"
    }
  ]
}
